var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDlpAttPriceValueYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#FDB400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 11.25C21.207 11.25 22 12.043 22 13V19.125C22 20.1094 21.207 20.875 20.25 20.875H9.75C8.76562 20.875 8 20.1094 8 19.125V10.375C8 9.41797 8.76562 8.625 9.75 8.625H19.8125C20.5234 8.625 21.125 9.22656 21.125 9.9375V10.375H10.1875C9.94141 10.375 9.75 10.5938 9.75 10.8125C9.75 11.0586 9.94141 11.25 10.1875 11.25H20.25ZM19.375 16.9375C19.8398 16.9375 20.25 16.5547 20.25 16.0625C20.25 15.5977 19.8398 15.1875 19.375 15.1875C18.8828 15.1875 18.5 15.5977 18.5 16.0625C18.5 16.5547 18.8828 16.9375 19.375 16.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpAttPriceValueYellow);
export default __webpack_public_path__ + "static/media/DlpAttPriceValueYellow.0022984a173d27879ac65c826039aa50.svg";
export { ForwardRef as ReactComponent };